import {
  Grid,
  Typography,
  Card,
  Box,
  Button,
  Link
  
} from "@mui/material";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAppSelector} from "../../app/store/configureStore";
import {FieldValues, useForm} from "react-hook-form";
import AppTextInput from "../../app/components/AppTextInputCustom";
import AppSelectListStates from "../../app/components/AppSelectListCustomStates";
import AppSelectList from "../../app/components/AppSelectListCustom";
import agent from "../../app/api/agent";
import PropertyQRCode from "../../app/components/PropertyQRCode";
import LoaderWithLinearProgress from "../../app/components/LoaderWithLinearProgress";

import {
    ArrowBackOutlined
} from "@mui/icons-material";
import { toast } from "react-toastify";

const InvitePartner = () => {
  const {user} = useAppSelector((state: any) => state.account);
  const navigate = useNavigate();
  const countries = ["United Kingdom"];
    const usStates = ["England", "Wales"];

  const [loading, setLoading] = useState(false);
  const {
    control,
    handleSubmit,
  } = useForm();
  const [openModal, setOpenModal] = useState(false);
  const [link, setLink] = useState("");

  if (!user) {
    navigate("/login");
  }

  // async function handleSubmitData(data: FieldValues) {
  //   setLoading(true);
  //   try {
  //     console.log(data);
  //     await agent.Marketplace.create(data)
  //       .then((response) => {
  //         setOpenModal(true);

  //         const test = handleQRLink(`/property/nouser/det/${response.id}`);

  //         setLink(test);
  //       })
  //       .catch((error) => console.log(error));
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   setLoading(false);
  // }

  async function handleSubmitData(data: FieldValues) {
    setLoading(true);
    try { 
      toast.info('Functionality under development, Data will not be saved');
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }

  function handleQRLink(url: any) {
    let currentURL = window.location.hostname;

    var withoutProtocol = currentURL.replace(/^https?:\/\//, "");

    // Remove path and query string
    var domain = withoutProtocol.split("/")[0];

    // Remove port number if present
    domain = domain.split(":")[0];

    let fullAddress = domain.concat(url);

    console.log(fullAddress);

    return fullAddress;
  }

  async function cancelEdit() {
    navigate("/my-network");
  }

  if (loading) return <LoaderWithLinearProgress />;

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#F4F4F4",
          height: "100%",
          width: "100%",
          padding: "20px",
          paddingTop: 0,
        }}
      >        
        <Box
          sx={{
            display: "flex",
            flex: "1",
            width: "100%",
            alignItems: "center",
            position: "sticky",
            backgroundColor: "#F5F5F5",
            top: 0,
            height: "60px",
            zIndex: "10",
            cursor:"pointer"
          }}
           onClick={() => {
              navigate("/my-network");
            }}
        >
          <ArrowBackOutlined sx={{ mr: 1, fontSize: '1.2rem' }} /> {/* Icon with right margin */}
          <Typography variant="body1" sx={{ fontWeight: 'medium' }}>Back to Network</Typography> {/* Text with font styling */}
        </Box>

        <form onSubmit={handleSubmit(handleSubmitData)}>
          <Card sx={{padding: "20px"}}>
            <Grid
              container
              spacing={3}
              sx={{
                display: "inline-flex",
                flexDirection: "row",
                width: "100%",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              <Grid item xs={12}>
                <Typography
                  component="h1"
                  variant="h5"
                  sx={{
                    fontFamily: "Roboto",
                    color: "#424242",
                    fontWeight: "600",
                    fontSize: "23px",
                    paddingTop: "30px",
                  }}
                >
                  Invite Partner
                </Typography>
              </Grid>

               <Grid item xs={6}>
                <AppTextInput
                 
                  label="First Name"
                  type="text"
                  name="FirstName"
                  control={control}
                  required
                />
              </Grid>

              <Grid item xs={6}>
                <AppTextInput
                  label="Last Name"
                  type="text"
                  name="LastName"
                  control={control}
                  required
                />
              </Grid>
               <Grid item xs={6}>
                <AppTextInput
                 
                  label="Phone"
                  type="text"
                  name="phone"
                  control={control}
                  required
                />
              </Grid>

              <Grid item xs={6}>
                <AppTextInput
                  label="Email"
                  type="text"
                  name="email"
                  control={control}
                  required
                />
              </Grid>

              

              <Grid item xs={4}>
                <AppTextInput
                  label="Address"
                  type="text"
                  name="AddressLine"
                  control={control}
                  required
                />
              </Grid>

              <Grid item xs={4}>
                <AppSelectList
                  control={control}
                  items={countries}
                  label="Country"
                  name="Country"
                  required
                />
              </Grid>

              <Grid item xs={4}>
                <AppSelectListStates
                  control={control}
                  items={usStates}
                  label="State"
                  name="State"
                  required
                />
              </Grid>

              <Grid item xs={6}>
                <AppTextInput
                  control={control}
                  type="text"
                  label="City"
                  name="City"
                  required
                />
              </Grid>

              <Grid item xs={6}>
                <AppTextInput
                  control={control}
                  label="Postal Code"
                  type="text"
                  name="PostalCode"
                  required
                />
              </Grid>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  paddingTop: "25px",
                  paddingX: "5px",
                }}
              >
                <Link underline="none" href="https://www.google.com/maps/">
                  <Button
                    variant="outlined"
                    sx={{
                      color: "#00838F",
                      fontFamily: "Roboto",
                      fontStyle: "normal",
                      fontSize: "0.875rem",
                      fontWeight: "400",
                      letterSpacing: "1.25px",
                      width: "240px",
                    }}
                    type="submit"
                  >
                    Search via Google Maps
                  </Button>
                </Link>
                <Button
                  
                  sx={{
                    background: "#00838F",
                    "&.MuiButtonBase-root:hover": {
                      bgcolor: "#00838F",
                    },
                    fontFamily: "Roboto",
                    fontStyle: "normal",
                    fontSize: "0.875rem",
                    fontWeight: "400",
                    color: "#fff",
                    letterSpacing: "1.25px",
                    width: "150px",
                    marginRight: "20px"
                  }}
                  type="submit"
                >
                  Invite Partner
                </Button>
              </Box>

            </Grid>

          
          </Card>
          
        </form>
      </Box>
      <PropertyQRCode open={openModal} link={link} />
    </>
  );
};

export default InvitePartner;
